import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms"

export class PasswordChangeForm extends UntypedFormGroup {

    constructor() {
        super({
            'currentPassword': new UntypedFormControl('',
                [
                    Validators.required
                ]
            ),
            'newPassword': new UntypedFormControl('',
                [
                    Validators.required
                ]
            ),
            'confirmPassword': new UntypedFormControl('',
                [
                    Validators.required
                ]
            ),
        })
    }
}
